import React from 'react';

import {LOGIN_URL} from '../staticTypes'


const Footer = () => {

	return (
		<div className="panel-footer">
			<a href={LOGIN_URL}>
				<div className="powered-by-container">
					<div className="powered-by-wantdo-icon mr-2"></div>
					<div className="powered-by-text"> Login </div>
				</div>
			</a>
		</div>
	)
}

export default Footer;